import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link, Icon } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import { connect } from '../../Store';
import { __, getPositionLabel } from '../../Utils';

const Wrapper = styled.div`
  font-family: 'Open Sans';
  font-weight: 100;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(40)};
  padding: ${rem(15)} ${rem(20)};
  background-color: #f1f1f1;
  width: calc(100% - 40px);
  ${({ theme }) => theme.media.m`
  flex-direction: row;
`};
`;

const LeftSubWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${rem(250)};
  ${({ theme }) => theme.media.m`
  align-items: baseline;
  padding-top: ${rem(15)}
`};
`;

const NameWrapper = styled.div`
  padding: 0 ${rem(30)};
`;

const ContactWrapper = styled.div`
  padding: ${rem(15)} 0;
`;

const PhoneWrapper = styled.div`
  display: flex;
  ${({ theme }) => theme.media.m`
  width: ${rem(300)}
`};
`;

const StyledIcon = styled(Icon)`
  margin-right: ${rem(10)};
`;

const Phone = styled.div`
  margin-bottom: ${rem(2)};
`;

const Email = styled(Link)``;

const RightSubWrapper = styled.div`
  width: 100%;
`;

const Name = styled.div`
  text-align: center;
  font-size: ${rem(20)};
  line-height: 1.1;
  display: flex;
  width: ${rem(100)}
    ${({ theme }) => theme.media.m`
  width: ${rem(200)}

`};
`;

const Position = styled.div`
  color: #989a9b;
  text-align: center;
  display: flex;
  justify-content: center;
  width: ${rem(100)}
    ${({ theme }) => theme.media.m`
  width: ${rem(200)}
  justify-content: start;


`};
`;

const MainHeading = styled.div`
  text-align: center;
  font-size: ${rem(24)};
  margin-bottom: ${rem(15)};
  line-height: 1.2;
`;

// const ProfilePicture = styled.div`
//   height: ${rem(80)};
//   width: ${rem(60)};
//   background-color: white;
// `;

const MultiContactsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${({ theme }) => theme.media.m`
justify-content: flex-end;
flex-direction: row;
`};
`;

class ContactInfoPanel extends React.Component {
  render() {
    const { contacts } = this.props;

    return (
      <Wrapper>
        <LeftSubWrapper>
          <MainHeading>
            {contacts.length === 1
              ? __('Vašim kontaktom je:')
              : __('Vašimi kontaktmi sú:')}
          </MainHeading>
        </LeftSubWrapper>
        <RightSubWrapper>
          {contacts.map(contact => {
            return (
              <MultiContactsWrapper>
                {/* <ProfilePicture /> */}
                <NameWrapper>
                  <Name>{contact.display_name}</Name>
                  <Position>{getPositionLabel(contact.role)}</Position>
                </NameWrapper>
                <ContactWrapper>
                  <PhoneWrapper>
                    <StyledIcon size="s" name="smartphone" />{' '}
                    <Phone>{contact.mobile}</Phone>
                  </PhoneWrapper>
                  <PhoneWrapper>
                    <StyledIcon size="s" name="envelope" />
                    <Email>{contact.email}</Email>
                  </PhoneWrapper>
                </ContactWrapper>
              </MultiContactsWrapper>
            );
          })}
        </RightSubWrapper>
      </Wrapper>
    );
  }
}

ContactInfoPanel.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape()),
};

ContactInfoPanel.defaultProps = {
  contacts: [],
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ContactInfoPanel);



// WEBPACK FOOTER //
// ./src/Components/ContactInfoPanel/index.jsx